module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "chapter"
  }, [_vm._v("CHAPTER IV.")]), _vm._v(" "), _c('p', {
    staticClass: "head"
  }, [_vm._v("AT THE HOSPITAL.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_vm._v("On a neat bed, at the Bellevue Hospital, old Jacob was stretched out. He had been in considerable pain, but opiates had been administered, and he was in an uneasy slumber.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_vm._v("Tom presented himself at the office below as soon as he could after hearing of the accident.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_vm._v("\"Is he much hurt? Is he in danger?\" he asked, anxiously, for Jacob was nearer to him than any one else.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_vm._v("\"He is now sleeping, and must not be disturbed. Come tomorrow, and we can tell you more,\" was the reply.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_vm._v("\"You can tell me if he was much hurt.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_vm._v("\"One leg is broken, but we cannot yet tell whether he has received any internal injury. All depends upon that.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_vm._v("Tom presented himself the next day. This time the physician looked grave.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_vm._v("\"We have reason to think that he is injured internally. His life is uncertain.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_vm._v("\"Poor Jacob!\" murmured Tom, moved by pity for the old man.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_vm._v("\"Is he your grandfather?\" asked the physician.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_vm._v("\"No; but I have lived with him for some years. Can I see him?\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_vm._v("\"Yes.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_vm._v("Tom followed the doctor into a long hall lined with beds. About midway, on the left hand side, he recognized the form of his old companion.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_vm._v("\"I am sorry to see you here, Jacob,\" said Tom, gently.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_vm._v("\"I'm almost dead,\" said the old man, peevishly. \"The man drove over me on purpose.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_vm._v("\"I hope not.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_vm._v("\"I tell you he did!\" said Jacob, irritably.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_vm._v("\"Well, Jacob, it can't be helped. You must try to get well.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_vm._v("\"I'm an old man. I'm afraid I shall never get well again,\" and he looked eagerly into Tom's face.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_vm._v("Having heard what he did from the doctor, Tom was placed in an awkward position. He was too honest to give false hopes, and he remained silent.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_vm._v("\"What did the doctor tell you?\" demanded Jacob, suspiciously.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_vm._v("\"He said he could not tell whether you would get well or not.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_vm._v("\"He thought I was going to die?\" said the old man, nervously.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_vm._v("\"He didn't say that.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_vm._v("\"I don't want to die,\" moaned the old man, terrified. \"I'm only sixty-five. My father lived to be seventy-five.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_vm._v("\"You may live, Jacob.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_vm._v("\"I—I'm not ready to die. Ask the doctor to do all he can.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_vm._v("\"He will be sure to do that.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_vm._v("There was a pause. The old man's features were convulsed. He had not till now thought that he was in danger of dying. He was trying to realize the terrible fact. Tom stood by in silence, for he had some idea of Jacob's feelings, and he pitied him.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_vm._v("At length the old man turned his face again toward him, and said:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_vm._v("\"Tom?\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_vm._v("\"What is it, Jacob?\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_vm._v("\"I want you to ask the doctor every day if he thinks I am going to die; and, when he says there is no hope, tell me.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_vm._v("\"Yes, Jacob.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_vm._v("\"Do you promise?\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_vm._v("\"Yes, I promise.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_vm._v("\"There is something I must tell you before I die—something important. Do you hear?\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_vm._v("\"Yes, I hear.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_vm._v("\"It's something you ought to know. Now you can go. I want to sleep.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_vm._v("\"Perhaps it is something about my father,\" thought Tom, with vague curiosity.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_vm._v("It was a matter that he had never troubled himself much about, but now it did occur to him that he should like to know a little more about himself. He determined to keep faithfully the promise he had made the old man.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_vm._v("He was destined to have one more adventure before the day closed.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_vm._v("On leaving the hospital Tom directed his course to Broadway. It was the busiest part of the day, and the street was crowded with stages, drays, and other vehicles, making it difficult to cross.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_vm._v("A hump-backed seamstress stood on the sidewalk, looking helplessly across, but not daring to venture on the perilous passage. There was no policeman in sight.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_vm._v("\"I wish I could get across,\" she said, loud enough to be heard. \"Mother won't know what has become of me.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_vm._v("Tom saw her anxious face, and stepped up at once.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_vm._v("\"I will take you across, miss,\" he said, politely.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_vm._v("\"Will you?\" she asked, her face brightening. \"I shall be very much obliged to you. My poor mother is sick at home, waiting for some medicine I went out to get for her, and I have been standing here ten minutes, not daring to cross. I don't know when Broadway has been so full.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_vm._v("\"Take my arm,\" said Tom, \"and don't be afraid.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_vm._v("She had scarcely taken our hero's arm, when a rude street-boy called out, in derision:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_vm._v("\"Is that your girl, Tom? Ask her what she will take for her hump.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_vm._v("\"I'll lick you when I come back,\" retorted Tom. \"Don't mind what he says, miss.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_vm._v("\"I don't,\" said the seamstress; \"I'm used to it,\" she added with a patient sigh.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_vm._v("\"Don't think about it,\" said Tom.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_vm._v("\"You are not ashamed to be seen with a hunchback?\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_vm._v("\"There ain't no cause.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_vm._v("By this time Tom had skillfully threaded his way with his companion across the street, and landed her in safety on the other side.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_vm._v("\"I am very much obliged to you,\" she said, gratefully. \"You're a gentleman.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_vm._v("With these words she nodded, and walked hastily away.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_vm._v("\"A gentleman!\" repeated Tom, thoughtfully. \"Nobody ever called me that before. My clo'es don't look much like it. Maybe it ain't all in the clo'es. I'd like to be a gentleman, and,\" he added, impulsively, \"I mean to be one, some time. I'll have to change my business fust, though. Gentlemen don't generally black boots for a livin'.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_vm._v("It was a passing thought that came to him by chance, his desire to grow up a gentleman, but he was more than half in earnest. He had not thought much about the future hitherto, but now his ambition was kindled, and he thought he should like to fill a respectable place in society.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_vm._v("What road should he take to the success which he coveted?")]), _vm._v(" "), _c('div', {
    staticClass: "calibre6",
    attrs: {
      "id": "calibre_pb_7"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5e34d0c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0005.vue
// module id = 69
// module chunks = 0